import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { CompanyService } from '../../../services/company.service';


@Component({
  selector: 'app-company-picker',
  templateUrl: './company-picker.component.html',
  styleUrls: ['./company-picker.component.scss']
})
export class CompanyPickerComponent implements OnInit, OnChanges {
  @Input() accountId: number;
  @Input() disable: boolean = false;
  @Input() _placeholder: string = 'Please Select';
  @Output() onCompanyIdSet = new EventEmitter<number>();
  @Output() onCompanySet = new EventEmitter<any>();

  companyId: number;
  companys = [];
  companyName: string;
  constructor(private companyService: CompanyService) {
  }

  ngOnInit(): void {
    //console.log(this.accountId);
    this.companyService.getAll().then((companys) => {
      this.companys = companys;
      
    });
    ////console.log("_placeholder: " + this._placeholder)
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.accountId != null && changes.accountId.currentValue != null) {
      if (this.companyId != changes.accountId.currentValue != null)
        this.companyId = changes.accountId.currentValue;


      this.companyService.getAll().then((companys) => {
        this.companys = companys;
        if (this.accountId != undefined && this.accountId > 0) {
          var company = this.companys.find(a => a.id == this.accountId);
          this.companyName = company.name;
        }
      });
    }
  }

  onChanged() {
    this.onCompanyIdSet.emit(this.companyId);
    var company = this.companys.find(a => a.id == this.companyId);
    this.onCompanySet.emit(company);
  }

}
